<template>
   <KTCodePreview v-bind:title="'Thông tin phiếu cho mượn'"
    > <template v-slot:toolbar
      >
      <div
        class="row"
        v-if="stockSlip.id"
      >

        <div>
           <b-row
            class="mb-4 ml-4"
            style="vertical-align: middle; display: inline"
            > <EditToggle
              v-if="stockSlip.id"
              v-model="isEdit"
              id="customSwitch2"
              label="Chỉnh sửa"
            /> </b-row
          >
        </div>

      </div>
       </template
    > <template v-slot:preview
      > <StockSlipSkeleton
        :renderComponent="renderComponent"
        v-if="!renderComponent"
      />
      <div v-if="renderComponent">
        <b-row
            v-if="billId"
            class="col-md-12 mb-4 m-0 p-0"
          >
            <div class="lending-stock-slip-source-header">
              <i
                class="fas fa-file-contract text-warning mr-2"
                style="font-size: 1.2rem"
              ></i>
              <span>
                Từ phiếu bảo hành ID: 
                <span class="font-weight-bold cursor-pointer text-warning" @click="linkToWarranty(billId)">#{{
                  billId
                }}</span>
              </span>
            </div>
          </b-row>
         <b-row
          class="mb-4 col-12 mb-1 m-0 p-0 stock-slip-code-row"
          v-if="stockSlip.code"
          > <label class="font-weight-bold stock-slip-code-label"
            >Mã phiếu kho: <a class="text-primary">{{ stockSlip.code }}</a></label
          > </b-row
        > <b-row class="mb-4 col-12 m-0 p-0"
          > <StockSlipLending
            :stockSlip="stockSlip"
            :stores="filteredOptions"
            :reasons="filteredReasons"
            :contactTypes="contactTypes"
            :recipients="filterRecipients"
            @onSelectedSourceWarehouse="onSelectedSourceWarehouse"
            @onInputChangeSourceWarehouse="onInputChangeSourceWarehouse"
            @onSelectedReason="onSelectedReason"
            @onInputChangeReason="onInputChangeReason"
            @onRecipientTypeChange="onRecipientTypeChange"
            @onRecipientSelect="onRecipientSelect"
            @onRecipientInputChange="onRecipientInputChange"
            @onExpectedReturnAtChange="onExpectedReturnAtChange"
            :editable="isEdit"
          /> </b-row
        > <b-row class="mb-5 col-12 mb-1 m-0 p-0"
          > <StockSlipLendingProduct
            :editable="isEdit"
            :productItems="stockSlip.details"
            :storeId="stockSlip.sourceWarehouseId"
            :isSubmitting="isSubmitting"
            ref="stockSlipLendingProduct"
          /> </b-row
        >
      </div>
       </template
    > <template v-slot:foot
      > <b-button
        style="font-weight: 600; width: 70px; margin-right: 10px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        :disabled="!isEdit"
        >Lưu</b-button
      > <router-link
        to="/lending-stockslip"
        tag="button"
        > <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        > </router-link
      > </template
    > </KTCodePreview
  >
</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import ApiService from '@/core/services/api.service'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { makeToastFaile, makeToastSuccess, xoa_dau } from '@/utils/common'
  import map from 'lodash/map'
  import forIn from 'lodash/forIn'
  import isArray from 'lodash/isArray'
  import { formatDBDate, convertToDateSlash, DATE_FORMAT, DATETIME_DB_FORMAT } from '@/utils/date'
  import { LENDING_STOCKSIP } from '@/utils/constants'
  import { cmdUrl } from '@/utils/apiUrl'
  import StockSlipSkeleton from '@/view/components/stock-slips/StockSlipSkeleton.vue'
  import StockSlipLending from '@/view/components/stock-slips/StockSlipLending.vue'
  import StockSlipLendingProduct from '@/view/components/stock-slips/StockSlipLendingProduct.vue'
  import EditToggle from '@/view/components/common/EditToggle.vue'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        stockSlip: {
          id: null,
          code: '',
          type: LENDING_STOCKSIP,
          sourceWarehouseName: '',
          sourceWarehouseId: null,
          destinationWarehouseName: '',
          destinationWarehouseId: null,
          recipientType: null,
          recipientId: null,
          recipientName: '',
          expectedReturnAt: null,
          notes: '',
          relatedStockSlipId: null,
          relatedStockSlipCode: '',
          details: [],
        },
        filteredOptions: [],
        sourceWarehouses: [],
        reasons: [],
        filteredReasons: [],
        contactTypes: [
          { value: '1', text: 'Khách hàng' },
          { value: '4', text: 'Nhân viên' },
        ],
        filterRecipients: [],
        recipientSearchTimeout: null,
        isSubmitting: false,
        renderComponent: true,
        isEdit: false,
        billId: null,
      }
    },
    components: {
      KTCodePreview,
      StockSlipSkeleton,
      StockSlipLending,
      StockSlipLendingProduct,
      EditToggle,
    },
    async created() {
      this.filteredOptions = []
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.stores = stores
      this.fetchReason()
      this.filteredOptions = [...this.stores]
      if (currentStoreId && !this.stockSlip.sourceWarehouseId) {
        this.stockSlip.sourceWarehouseId = currentStoreId
        this.stockSlip.sourceWarehouseName = currentStoreName
      }
      this.stockSlip.id = this.$route.query?.id || null
      this.billId = this.$route.query?.billId || null
      if (this.stockSlip.id) {
        await this.getStockSlipByID()
      } else {
        this.isEdit = true
      }
    },
    methods: {
      linkToWarranty(billId) {
        const routeData = this.$router.resolve({ name: 'warranty-dispatch-info', query: {id: billId }});
        window.open(routeData.href, '_blank');
      },
      createStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            productId: element.productId,
            imeis,
            quantity: element.quantity,
          }
        })
        const payload = {
          sourceWarehouseId: this.stockSlip.sourceWarehouseId,
          description: this.stockSlip.notes,
          stockSlipType: this.stockSlip.type,
          reasonId: this.stockSlip.reasonId,
          recipientType: this.stockSlip.recipientType,
          recipientId: this.stockSlip.recipientId,
          recipientName: this.stockSlip.recipientName,
          expectedReturnAt: this.stockSlip.expectedReturnAt
            ? formatDBDate(this.stockSlip.expectedReturnAt, DATE_FORMAT, DATETIME_DB_FORMAT)
            : null,
          details,
        }
        if (this.billId) payload.billId = this.billId
        if (!payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho chuyển!')
        }
        if (!payload.reasonId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn lý do!')
        }

        if (!payload.details || payload.details.length === 0) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn sản phẩm!')
        }

        try {
          const url = 'v1/stock-status-transfer/lending-stock-slips'
          const res = await ApiService.post(url, payload).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-lending-stockslip',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      updateStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            id: element.id,
            productId: element.productId,
            imeis,
            quantity: element.quantity,
          }
        })

        const payload = {
          id: this.stockSlip.id,
          sourceWarehouseId: this.stockSlip.sourceWarehouseId,
          reasonId: this.stockSlip.reasonId,
          description: this.stockSlip.notes,
          recipientType: this.stockSlip.recipientType,
          recipientId: this.stockSlip.recipientId,
          recipientName: this.stockSlip.recipientName,
          expectedReturnAt: this.stockSlip.expectedReturnAt
            ? formatDBDate(this.stockSlip.expectedReturnAt, DATE_FORMAT, DATETIME_DB_FORMAT)
            : null,
          details,
        }
        if (!payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho chuyển!')
        }
        if (!payload.reasonId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn lý do!')
        }

        if (!payload.details || payload.details.length === 0) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn sản phẩm!')
        }

        if (this.billId) payload.billId = this.billId;
        try {
          const res = await ApiService.put(
            'v1/stock-status-transfer/lending-stock-slips',
            payload,
          ).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-lending-stockslip',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      onSubmit() {
        if (this.isSubmitting) return
        this.isSubmitting = true
        if (!this.stockSlip.id) {
          this.createStockSlip()
          return
        }
        this.updateStockSlip()
      },
      onSelectedSourceWarehouse(option) {
        this.stockSlip.sourceWarehouseName = option.item.name
        this.stockSlip.sourceWarehouseId = option.item.id
      },
      onInputChangeSourceWarehouse(text) {
        this.stockSlip.sourceWarehouseName = text
        const filteredData = this.stores
          .filter((item) => {
            return (
              xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, 10)
        this.filteredOptions = [...filteredData]
      },
      onSelectedReason(option) {
        this.stockSlip.reasonName = option.item.name
        this.stockSlip.reasonId = option.item.id
      },
      onExpectedReturnAtChange(value) {
        this.stockSlip.expectedReturnAt = value
      },
      onRecipientTypeChange() {
        this.filterRecipients = []
        this.stockSlip.recipientId = null
        this.stockSlip.recipientName = ''
      },
      onRecipientSelect(option) {
        this.stockSlip.recipientId = option.item.value
        this.stockSlip.recipientName = option.item.text
      },
      onRecipientInputChange(searchText) {
        clearTimeout(this.recipientSearchTimeout)
        this.recipientSearchTimeout = setTimeout(() => {
          this.stockSlip.recipientName = searchText
          const { recipientType } = this.stockSlip
          if (!recipientType) {
            this.filterRecipients = []
            return
          }
          let params = { page: 1, pageSize: 10 }
          let apiUrl = ''
          switch (recipientType) {
            case '1':
              apiUrl = cmdUrl.CustomerUrl.root
              params = { customerPhone: searchText, page: 1, pageSize: 10 }
              break
            case '4':
              apiUrl = cmdUrl.EmployeeUrl.root
              params = { fullName: searchText, page: 1, pageSize: 10 }
              break
            default:
              this.filterRecipients = []
              return
          }
          ApiService.query(apiUrl, {
            params: { ...params, param: params },
          }).then((response) => {
            const data = response.data.data || response.data
            let listResult = []
            forIn(data, (value) => {
              if (isArray(value)) listResult = value
            })
            this.filterRecipients = map(listResult, (item) => ({
              value: item.id,
              text:
                (item.name || item.fullName || item.customerName || '') +
                (item.phoneNo || item.customerPhone
                  ? ' - ' + (item.phoneNo || item.customerPhone)
                  : ''),
            }))
          })
        }, 250)
      },
      onInputChangeReason(text) {
        this.stockSlip.reasonName = text
        const filteredData = this.reasons
          .filter((item) => {
            return xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1
          })
          .slice(0, 10)
        this.filteredReasons = [...filteredData]
      },
      getStockSlipByID: async function () {
        this.renderComponent = false
        ApiService.get(`v1/stock-status-transfer/lending-stock-slips/${this.stockSlip.id}`).then(
          (data) => {
            const stockSlipData = data.data.data
            this.stockSlip.code = stockSlipData.code
            this.stockSlip.type = stockSlipData.type
            this.stockSlip.sourceWarehouseId = stockSlipData.storeId
            this.stockSlip.sourceWarehouseName = stockSlipData.storeName
            this.stockSlip.reasonId = stockSlipData.reasonId
            this.stockSlip.reasonName = stockSlipData.reasonName
            this.stockSlip.recipientType = stockSlipData.recipientType || null
            this.stockSlip.recipientId = stockSlipData.recipientId || null
            this.stockSlip.recipientName = stockSlipData.recipientName || ''
            this.stockSlip.expectedReturnAt =
              stockSlipData.expectedReturnAt || stockSlipData.lendingAt
                ? convertToDateSlash(
                    stockSlipData.expectedReturnAt || stockSlipData.lendingAt,
                    DATE_FORMAT,
                  )
                : null
            this.stockSlip.notes = stockSlipData.description
            this.stockSlip.details = stockSlipData.details.map((detail, index) => {
              return {
                ...detail,
                stt: index + 1,
                productPriceMask: detail.unitPrice,
                IMEI: detail.productImei || '',
              }
            })
            this.billId = stockSlipData.billId;
            this.renderComponent = true
          },
        )
      },
      fetchReason: async function () {
        this.filteredOptions = []
        ApiService.get('v1/stock-status-transfer/lending-reasons').then((response) => {
          this.reasons = response.data.data
          this.filteredReasons = [...this.reasons]
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .stock-slip-code-label {
  font-size: 0.875rem;
  color: #3f4254;
  .lending-stock-slip-source-header {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
}
</style>

